import { useEffect, useState } from "react";
import { UserRound, MessageCircleHeart, Eye } from "lucide-react";
import { api } from "../../lib/api";

const fmt = (iso) => iso ? new Date(iso).toLocaleString("nl-BE", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : null;

export const GuestsAdmin = () => {
  const [guests, setGuests] = useState(null);
  useEffect(() => { api.get("/admin/guests").then((r) => setGuests(r.data)).catch(() => setGuests([])); }, []);
  if (!guests) return null;
  return (
    <div data-testid="admin-guests-section" className="mb-10">
      <h2 className="font-heading font-bold text-lg flex items-center gap-2 mb-1"><UserRound className="w-5 h-5 text-primary" /> Gasten</h2>
      <p className="text-xs text-muted-foreground mb-4">Iedereen die via een uitnodigingslink toegang heeft tot een reisverslag. Elk bezoek via de link wordt geteld. Het bolletje naast het laatste bezoek toont of de server toen online (groen) of in storing (rood) was — alleen beschikbaar voor de laatste 7 dagen.</p>
      {guests.length === 0 ? (
        <p className="text-sm text-muted-foreground py-6 text-center bg-card rounded-2xl">Nog geen gasten uitgenodigd.</p>
      ) : (
        <div className="space-y-2" data-testid="admin-guests-table">
          {guests.map((g, i) => (
            <div key={`${g.email}-${i}`} data-testid={`admin-guest-row-${g.email}`}
              className="bg-card rounded-2xl px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-2">
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm truncate">{g.name}{g.email && <span className="text-muted-foreground font-normal"> · {g.email}</span>}</p>
                <p className="text-xs text-muted-foreground truncate">
                  Trip: {g.trip_name}{g.trip_owner ? ` (van ${g.trip_owner})` : ""}{g.invited_at ? ` · uitgenodigd ${fmt(g.invited_at)}` : ""}
                </p>
              </div>
              <div className="flex flex-wrap items-center gap-2 shrink-0 text-xs">
                <span data-testid={`guest-visits-${g.email}`}
                  className={`flex items-center gap-1 font-bold rounded-full px-2.5 py-1 ${g.visit_count > 0 ? "bg-emerald-100 text-emerald-700" : "bg-secondary text-muted-foreground"}`}>
                  <Eye className="w-3.5 h-3.5" /> {g.visit_count > 0 ? `${g.visit_count}× bezocht` : "nog niet geopend"}
                </span>
                {g.comment_count > 0 && (
                  <span data-testid={`guest-comments-${g.email}`} title="Aantal reacties van deze gast"
                    className="flex items-center gap-1 font-bold bg-[#B5838D]/15 text-[#8E5D67] rounded-full px-2.5 py-1">
                    <MessageCircleHeart className="w-3.5 h-3.5" /> {g.comment_count}
                  </span>
                )}
                {g.last_visit_at && (
                  <span className="font-mono text-muted-foreground flex items-center gap-1.5">
                    {g.server_ok_at_visit != null && (
                      <span data-testid={`guest-server-dot-${g.email}`}
                        title={g.server_ok_at_visit ? "Server was online bij dit bezoek" : "Server had een storing rond dit bezoek"}
                        className={`w-2 h-2 rounded-full inline-block shrink-0 ${g.server_ok_at_visit ? "bg-emerald-500" : "bg-red-500"}`} />
                    )}
                    laatst: {fmt(g.last_visit_at)}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
